import styled from 'styled-components';
import { Heading } from 'grommet';

export default styled(Heading)`
  font-family: 'Turret Road', cursive;
`;
